{
  "button": {
    "hide": "숨기기",
    "show": "보기",
    "rememberMe": "로그인 상태 유지",
    "forgotPassword": "비밀번호 찾기",
    "termsAndConditions": "이용약관",
    "seeMore": "더 보기",
    "search": "검색"
  },
  "title": {
    "signin": "로그인",
    "signingIn": "로그인 중",
    "loginWithOtherAccount": "다른 계정으로 로그인",
    "continueWithGG": "Google로 계속하기",
    "signUp": "회원가입",
    "signingUp": "회원가입 중",
    "continueWithKaKao": "카카오톡으로 계속하기",
    "home": "홈",
    "tours": "투어",
    "aboutUs": "회사 소개",
    "dashboard": "대시보드",
    "myProfile": "내 프로필",
    "signout": "로그아웃",
    "customerSupport": "고객 지원",
    "dropUsAnEmail": "이메일 보내기",
    "locations": "지점 위치",
    "followUsOn": "팔로우하기"
  },
  "msg": {
    "registeredSuccess": "회원가입이 완료되었습니다"
  },
  "valid": {
    "required": "필수 입력 항목입니다",
    "requiredInfor": "잘못된 정보입니다. 다시 입력해 주세요.",
    "passwordsDoNotMatch": "비밀번호가 일치하지 않습니다",
    "mustAcceptTerms": "계속하려면 이용약관에 동의해야 합니다."
  },
  "field": {
    "phone": "전화번호",
    "password": "비밀번호",
    "confirmPassword": "비밀번호 확인",
    "userName": "사용자 이름",
    "email": "이메일"
  },
  "or": "또는",
  "noAccount": "계정이 없으신가요",
  "haveAccount": "이미 계정이 있으신가요",
  "accept": "동의",
  "footerSlogan": "저희의 사명은 편안한 휴양, 신나는 모험, 또는 소중한 사람들과의 잊지 못할 여행을 계획하시는 모든 분들께 매끄럽고 즐거운 여행 경험을 제공하는 것입니다.",
  "whereDoYouWantToGo?": "어디로 가고 싶으신가요?",
  "departureDate": "출발 날짜",
  "travellerroom": "여행객 및 객실"
}
